import isType from './is-type';
export default (function (value) {
    return Array.isArray ?
        Array.isArray(value) :
        isType(value, 'Array');
});
//# sourceMappingURL=is-array.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.9@@antv/util/esm/is-array.js
// module id = null
// module chunks = 